import {
    CONTACTS_DELETE_ITEMS,
    CONTACTS_DELETE_ITEMS_ERROR, CONTACTS_DELETE_ITEMS_SUCCESS, CONTACTS_GET_LIST,
    CONTACTS_GET_LIST_ERROR,
    CONTACTS_GET_LIST_SEARCH, CONTACTS_GET_LIST_SUCCESS,
    CONTACTS_GET_LIST_WITH_FILTER,
    CONTACTS_GET_LIST_WITH_ORDER,
    CONTACTS_SELECTED_ITEMS_CHANGE
} from './actions_def';

const INIT_STATE = {
    allContactItems: [],
    contactsItems: [],
    errors: [],
    filter: null,
    searchKeyword: '',
    orderColumn: null,
    isLoaded: false,
    isLoading: false,
    saving: false,
    labels: [
        { label: 'EDUCATION', color: 'secondary' },
        { label: 'NEW FRAMEWORK', color: 'primary' },
        { label: 'PERSONAL', color: 'info' },
    ],
    orderColumns: [
        { column: 'title', label: 'Title' },
        { column: 'category', label: 'Category' },
        { column: 'status', label: 'Status' },
        { column: 'label', label: 'Label' },
    ],
    categories: ['Flexbox', 'Sass', 'React'],
    selectedItems: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CONTACTS_GET_LIST:
            return { ...state, isLoaded: false };

        case CONTACTS_GET_LIST_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                isLoaded: true,
                allContactItems: action.payload,
                contactsItems: action.payload,
            };

        case CONTACTS_GET_LIST_ERROR:
            return { ...state, isLoaded: true, error: action.payload };

        case CONTACTS_GET_LIST_WITH_FILTER:
            if (action.payload.column === '' || action.payload.value === '') {
                return {
                    ...state,
                    isLoaded: true,
                    contactsItems: state.allContactItems,
                    filter: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const filteredItems = state.allContactItems.filter(
                (item) => item[action.payload.column] === action.payload.value
            );
            return {
                ...state,
                isLoaded: true,
                contactsItems: filteredItems,
                filter: {
                    column: action.payload.column,
                    value: action.payload.value,
                },
            };

        case CONTACTS_GET_LIST_WITH_ORDER:
            if (action.payload === '') {
                return {
                    ...state,
                    isLoaded: true,
                    contactsItems: state.contactsItems,
                    orderColumn: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const sortedItems = state.contactsItems.sort((a, b) => {
                if (a[action.payload] < b[action.payload]) return -1;
                if (a[action.payload] > b[action.payload]) return 1;
                return 0;
            });
            return {
                ...state,
                isLoaded: true,
                contactsItems: sortedItems,
                orderColumn: state.orderColumns.find(
                    (x) => x.column === action.payload
                ),
            };

        case CONTACTS_GET_LIST_SEARCH:
            if (action.payload === '') {
                return { ...state, contactsItems: state.allContactItems };
            }
            // eslint-disable-next-line no-case-declarations
            const keyword = action.payload.toLowerCase();
            // eslint-disable-next-line no-case-declarations
            const searchItems = state.allContactItems.filter(
                (item) =>
                    item.title.toLowerCase().indexOf(keyword) > -1 ||
                    item.detail.toLowerCase().indexOf(keyword) > -1 ||
                    item.status.toLowerCase().indexOf(keyword) > -1 ||
                    item.category.toLowerCase().indexOf(keyword) > -1 ||
                    item.label.toLowerCase().indexOf(keyword) > -1
            );
            return {
                ...state,
                isLoaded: true,
                contactsItems: searchItems,
                searchKeyword: action.payload,
            };

        case CONTACTS_SELECTED_ITEMS_CHANGE:
            return { ...state, isLoaded: true, selectedItems: action.payload };

        case CONTACTS_DELETE_ITEMS:
            return {
                ...state,
                isLoaded: false,
                saving: true
            };

        case CONTACTS_DELETE_ITEMS_SUCCESS:

            return {
                ...state,
                isLoaded: true,
                saving: false,
                saved: true,
                errors: [],
                allContactItems: state.allContactItems.filter(item => item.id !== action.payload.rfc_id),
                contactsItems: state.contactsItems.filter(item => item.id !== action.payload.rfc_id),
            };

        case CONTACTS_DELETE_ITEMS_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoaded: true,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        default:
            return { ...state };
    }
};
